import React from 'react';
import Chess from 'chess.js';
import { Chessboard, INPUT_EVENT_TYPE, MOVE_INPUT_MODE } from 'cm-chessboard';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { joinGame, leaveGame } from '../actions/game';

import BoardController from '../components/BoardController';

import '../styles/game-room.css';
import '../styles/board-controller.css';
import '../styles/cm-chessboard.css';

const ENDPOINT = "http://127.0.0.1:8080";

const io = require("socket.io-client");
const socket = io(ENDPOINT, {
  transports: ['websocket', 'polling', 'flashsocket']
});

class UnwrappedGameRoom extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 'Game start. White to move.',
      fenId: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
      pgn: '',
      color: '',
      showPromotion: false,
      promotionSelection: '',
      promotionSelected: false,
      history: [],
      gameOverStatus: null,
      showAcceptDraw: false,
      drawOfferSent: false,
      spectatorView: false,
      roomId: this.props.location.state.roomId,
      player: this.props.authedUser,
      faction: this.props.location.state.faction,
      whiteFaction: 0,
      blackFaction: 0,
      whiteVisible: true,
      blackVisible: true,
      modalOpen: false,
      powers: [
        'PROMOTION',
        'CAMOUFLAGE'
      ]
    };

    this.game = new Chess();

    // game.load(this.state.fenId)

    socket.emit('requestGame', {
      roomId: this.state.roomId,
      player: this.state.player,
    });

    socket.emit('addPlayer', {
      roomId: this.state.roomId,
      player: this.state.player,
      faction: this.state.faction
    })

    socket.on('roomFull', data => {
      socket.emit('assignPlayers', {
        roomId: data.roomId,
        player: this.state.player,
        gameData: this.game
      });
    })

    socket.on('playerReady', data => {
      this.setState({
        color: data.playerColor,
        whiteFaction: data.whiteFaction,
        blackFaction: data.blackFaction
      });
    })

    socket.on('broadcastMove', data => {
      if (data.roomId === this.state.roomId) {
        this.game.move({
          from: data.move.from,
          to: data.move.to,
          promotion: data.move.promotion,
          faction: data.move.faction
        });
        this.setState({
          fenId: data.fenId,
          history: data.history,
          status: data.status
        })
      }
    });

    socket.on('sendGameData', data => {
      this.game.load(data.fen);

      console.log(data)

      this.setState({
        fenId: data.fen,
        color: data.color,
        history: data.history,
        status: data.status,
        whiteFaction: data.whiteFaction,
        blackFaction: data.blackFaction
      });

      this.board.setPosition(this.state.fenId);
      this.board.setOrientation(this.state.color);
    })

    socket.on('sendGameOverData', data => {      
      if (data.type === 'DRAW OFFERED') {
        this.setState({
          status: data.statusText,
          showAcceptDraw: true,
          drawOfferSent: true
        })
      } else if (data.type === 'DRAW CANCELLED') {
        this.setState({
          status: data.statusText,
          showAcceptDraw: false,
          drawOfferSent: false
        })
      } else {
        this.props.leaveGameAction();

        this.setState({
          status: data.statusText,
          gameOverStatus: true
        })
      }
    })

    this.onDrop = (move) => {
      if (move === null) {
        return 'snapback'
      } else {
        let gameStatus = '';
        let moveColor = 'White';

        if (this.game.turn() === 'b') {
          moveColor = 'Black';
        }
        if (this.game.in_checkmate()) {
          gameStatus = 'Game over, ' + moveColor + ' is in checkmate.';
          this.props.leaveGameAction();
        } else if (this.game.in_draw()) {
          gameStatus = 'Game over, drawn position.';
          this.props.leaveGameAction();
        } else {
          gameStatus = moveColor + ' to move.';

          if (this.game.in_check()) {
            gameStatus += ' ' + moveColor + ' is in check.';
          }
        }

        socket.emit('move', {
          move: move,
          promotion: move.promotion,
          fenId: this.game.fen(),
          roomId: this.state.roomId,
          status: gameStatus
        });
      }
    }

    this.setGameOverStatus = (gameOverType) => {
      socket.emit('requestGameOver', {
        roomId: this.state.roomId,
        playerId: this.state.player.id,
        type: gameOverType
      });
    }

    // let onMouseoverSquare = function (square, piece) {
    //   // get list of possible moves for this square
    //   let moves = this.game.moves({
    //     square: square,
    //     verbose: true
    //   });
  
    //   // exit if there are no moves available for this square
    //   if (moves.length === 0) return;
  
    //   // highlight the square they moused over
    //   // greySquare(square);
  
    //   // highlight the possible squares for this piece
    //   for (let i = 0; i < moves.length; i++) {
    //     // greySquare(moves[i].to);
    //   }
    // };

    // let onMouseoutSquare = function (square, piece) {
    //   // removeGreySquares();
    // };
  }

  componentDidMount() {
    this.board = new Chessboard(document.getElementById("board"), {
      position: this.game.fen(),
      orientation: this.state.color,
      moveInputMode: MOVE_INPUT_MODE.dragPiece,
      responsive: true,
      whiteFaction: this.state.whiteFaction,
      blackFaction: this.state.blackFaction,
      whiteVisible: true,
      blackVisible: true,
      animationDuration: 300,
      style: {
        cssClass: "default",
        showCoordinates: true,
        showBorder: false,
        aspectRatio: 1
      },
      sprite: {
        url: "./assets/chessboard-sprite.svg",
        grid: 40
      }
    });
    this.board.enableMoveInput(this.inputHandler);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.fenId !== this.state.fenId) {
      this.board.setPosition(this.state.fenId);
      this.board.props.position = this.state.fenId;
    }
    if (this.state.gameOverStatus || this.game.game_over()) {
      this.board.disableMoveInput()
    }
    this.board.setOrientation(this.state.color);
    this.board.props.whiteFaction = this.state.whiteFaction;
    this.board.props.blackFaction = this.state.blackFaction;
    this.board.props.whiteVisible = this.state.whiteVisible;
    this.board.props.blackVisible = this.state.blackVisible;
  }

  promotionSelectAsync(callback) {
    const loop = () => {
      this.setState({ showPromotion: true })
      if (!this.state.promotionSelected) {
        console.log('tewrte')
        setTimeout(loop, 0);
      } else {
        callback();
      }
    }
    loop();
  }

  inputHandler = (event) => {
    if (event.type === INPUT_EVENT_TYPE.moveDone) {
      if (this.game.turn() === this.state.color) {
        const move = { from: event.squareFrom, to: event.squareTo, promotion: 'q', faction: this.state.faction }
        const result = this.game.move(move)

        if (result && (result.flags === 'p' || result.flags === 'cp')) {
          this.promotionSelectAsync(() => {
            const promotionMove = { from: event.squareFrom, to: event.squareTo, promotion: this.state.promotionSelection, faction: this.state.faction }
            const promotionResult = this.game.move(promotionMove)

            event.chessboard.setPosition(this.game.fen());
            this.setState({
              fenId: this.game.fen(),
              // promotionSelection: '',
              promotionSelected: false,
              showPromotion: false
            });
            this.onDrop(promotionMove);
            console.log('!!!!!!!!!')
            return promotionResult;
          })
        } else if (result) {
          event.chessboard.setPosition(this.game.fen());
          this.setState({
            fenId: this.game.fen(),
            // history: this.game.history(),
            // squareStyles: squareStyling({toSquare: event.squareTo, history: this.game.history({verbose: true})}),
          });
          this.onDrop(move);
          return result;
        } else {
          console.warn('invalid move', move);
        }
      } else {
        console.warn("It's not your turn");
      }
    } else {
      return true;
    }
  }

  render() {
    // console.log(this.state.showAcceptDraw)
    return (
      <div className="game-room">
        {/* <div className="controller">
          {this.state.powers.map((power, i) => {
            return <p className="power" key={i}>
              {power}
            </p>
          })}
        </div> */}
        <div className="controller">
          {this.state.showPromotion &&
            <div className="promotion">
              <button onClick={() => { this.setState({ promotionSelected: true, showPromotion: false, promotionSelection: 'q' }) }}>
                <svg className="piece" data-piece="q">
                  <use data-piece="q" xlinkHref={`#${this.state.faction}${this.state.color}q`}></use>
                </svg>
              </button>
              <button onClick={() => { this.setState({ promotionSelected: true, showPromotion: false, promotionSelection: 'r' }) }}>
                <svg className="piece" data-piece="r">
                  <use data-piece="r" xlinkHref={`#${this.state.faction}${this.state.color}r`}></use>
                </svg>
              </button>
              <button onClick={() => { this.setState({ promotionSelected: true, showPromotion: false, promotionSelection: 'b' }) }}>
                <svg className="piece" data-piece="b">
                  <use data-piece="b" xlinkHref={`#${this.state.faction}${this.state.color}b`}></use>
                </svg>
              </button>
              <button onClick={() => { this.setState({ promotionSelected: true, showPromotion: false, promotionSelection: 'n' }) }}>
                <svg className="piece" data-piece="n">
                  <use data-piece="n" xlinkHref={`#${this.state.faction}${this.state.color}n`}></use>
                </svg>
              </button>
              <button onClick={() => { this.setState({ promotionSelected: true, showPromotion: false, promotionSelection: 's' }) }}>
                <svg className="piece" data-piece="s">
                  <use data-piece="s" xlinkHref={`#${this.state.faction}${this.state.color}s`}></use>
                </svg>
              </button>
            </div>
          }
        </div>
        <div className="boardview">
          <div
            id='board'
            style={{
              float: "left",
              maxWidth: '80vh',
              maxHeight: '80vh',
              width: `calc(100vw - 40px)`,
              height: `calc(95vw - 40px)`
            }}
          >
            {/* <button onClick={() => this.setState({ modalOpen: true })}>Open Modal</button>
            <ReactModal
              isOpen={this.state.modalOpen}
              shouldCloseOnOverlayClick={true}
              shouldCloseOnEsc={true}
              ariaHideApp={false}
            >
              <button onClick={() => this.setState({ modalOpen: false })}>Close Modal</button>
              <button onClick={() => this.setState(prevState => ({
                blackVisible: !prevState.blackVisible
              }))}>
                Visibility: {`${this.state.blackVisible}`}
              </button>
            </ReactModal> */}
          </div>
        </div>
        <BoardController
          controller="controller"
          endGame={this.setGameOverStatus}
          gameOver={this.game.game_over()}
          gameOverStatus={this.state.gameOverStatus}
          showAcceptDraw={this.state.showAcceptDraw}
          drawOfferSent={this.state.drawOfferSent}
          spectatorView={this.state.spectatorView}
          statusText={this.state.status}
          history={this.state.history}
        />
      </div>
    )
  }
}

function mapStateToProps ({ authedUser, inGame }) {
  return {
    authedUser,
    inGame
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    joinGameAction: () => {
      dispatch(joinGame()) 
    },
    leaveGameAction: () => {
      dispatch(leaveGame())
    } 
  }
}

export const GameRoom = connect(mapStateToProps, mapDispatchToProps)(withRouter(UnwrappedGameRoom));